import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Stack, Theme, Typography, useTheme } from '@rhg/libs/material';

const styleLeftAction = {
    position: 'absolute',
    left: 0,
};
const styleRightAction = {
    position: 'absolute',
    right: 0,
};
const styleHeaderContainer = {
    position: 'relative',
    width: '100%',
    my: (theme: Theme) => ({
        sm: theme.ds.spacingUnits.CONTENT,
        md: theme.ds.spacingUnits.SECTION,
    }),
};

interface ActionsHeaderProps {
    title?: string;
    /** Supporting line rendered under the title. */
    subtitle?: string;
    leftAction?: React.ReactNode;
    rightAction?: React.ReactNode;
}

export function ActionsHeader({
    title,
    subtitle,
    leftAction,
    rightAction,
}: ActionsHeaderProps) {
    const theme = useTheme();
    const isMobile = useIsMobile();
    if (!title && !subtitle && !leftAction && !rightAction) {
        return null;
    }
    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width="100%"
            my={theme.ds.spacingUnits.SECTION}
            sx={styleHeaderContainer}
        >
            <Box sx={styleLeftAction}>{leftAction}</Box>
            {title || subtitle ? (
                <Box flexGrow={1} textAlign="center">
                    {title ? (
                        <Typography
                            variant={isMobile ? 'h6' : 'h5'}
                            component="h1"
                            color="text.primary"
                        >
                            {title}
                        </Typography>
                    ) : null}
                    {subtitle ? (
                        <Typography
                            variant="subtitle1"
                            component="p"
                            color="text.sub"
                        >
                            {subtitle}
                        </Typography>
                    ) : null}
                </Box>
            ) : null}
            <Box sx={styleRightAction}>{rightAction}</Box>
        </Stack>
    );
}
